import React, { useEffect, useMemo, useState, memo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams, useRouteMatch, Redirect } from 'react-router-dom';

import Actions from '../../../store/ducks/appointments';

import { useAppointments } from '../context';
import { NewAppointmentProvider } from './context';
import Schedule from './Schedule';
import Informations from './Informations';
import Confirmation from './Confirmation';
import Send from './Send';

const NewAppointment = () => {
  const { handleShowSideMenu, setNewApppointmentStep } = useAppointments();
  const { step } = useParams();
  const { path } = useRouteMatch();
  const dispatch = useDispatch();
  const { new: newAppointment } = useSelector(state => state.appointments);
  const [mounted, setMounted] = useState(false);

  const { sending, id, error } = useMemo(() => newAppointment, [
    newAppointment,
  ]);

  const ComponentStep = useMemo(() => {
    /* *
     TODO:
     Ajustar forma como chama o setNewAppointStep.
     Ele não deve ser chamado no momento que está renderizando esse componente aqui...
     * */
    switch (step) {
      case 'schedule':
        setNewApppointmentStep(1);
        return Schedule;
      case 'informations':
        setNewApppointmentStep(2);
        return Informations;
      case 'confirmation':
        setNewApppointmentStep(3);
        if (!sending && !id && !error) {
          return Confirmation;
        }
        return Send;
      default:
        return false;
    }
  }, [step, setNewApppointmentStep, sending, id, error]);

  useEffect(() => {
    if (!mounted && (sending || id || error)) {
      dispatch(Actions.updateNewAppointment(false, null, ''));
    }
  }, [mounted, sending, id, error, dispatch]);

  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    handleShowSideMenu(false);
  }, [handleShowSideMenu]);

  return (
    <>
      <NewAppointmentProvider>
        {ComponentStep ? (
          <ComponentStep />
        ) : (
          <Redirect to={path.replace(':step', 'schedule')} />
        )}
      </NewAppointmentProvider>
    </>
  );
};

export default memo(NewAppointment);
